import { useEffect, useState } from 'react';
import api from '../services/api';

export interface Provincia {
  sigla: string;
  nome: string;
  /** Provincia sarda soppressa: il Gestionale la tiene, i form non la propongono. */
  soppressa: boolean;
}

let cache: Promise<Provincia[]> | null = null;

function caricaProvince(): Promise<Provincia[]> {
  if (!cache) {
    cache = api.get<{ province: Provincia[] }>('/api/lookups/province')
      .then(r => r.data.province)
      .catch(err => { cache = null; throw err; });
  }
  return cache;
}

/** Le province del Gestionale (`tabprov`), lette una volta per sessione del browser. */
export function useProvince(): Provincia[] {
  const [province, setProvince] = useState<Provincia[]>([]);
  useEffect(() => {
    let attivo = true;
    caricaProvince().then(p => { if (attivo) setProvince(p); }).catch(() => {});
    return () => { attivo = false; };
  }, []);
  return province;
}
